import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=0ba0a0db&scoped=true&"
import script from "./ContactList.vue?vue&type=script&lang=js&"
export * from "./ContactList.vue?vue&type=script&lang=js&"
import style0 from "./ContactList.vue?vue&type=style&index=0&id=0ba0a0db&lang=scss&scoped=true&"
import style1 from "./ContactList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0a0db",
  null
  
)

export default component.exports